import React from 'react';
import { 
  HelpCircle, 
  Droplets, 
  PaintBucket, 
  Layers, 
  Palette, 
  Shield, 
  Zap, 
  Sparkles 
} from 'lucide-react';

const TipsSidebar = () => {
  const tips = [
    {
      icon: Droplets,
      title: 'Выбор краски',
      description: 'Выбирайте краску в зависимости от типа помещения. Для влажных помещений - влагостойкая, для детской - экологичная.'
    },
    {
      icon: Layers,
      title: 'Подготовка поверхности',
      description: 'Тщательно очистите, зашпаклюйте и загрунтуйте поверхность перед покраской для лучшего результата.'
    },
    {
      icon: PaintBucket,
      title: 'Количество слоев',
      description: 'Наносите как минимум 2 слоя для равномерного покрытия и насыщенного цвета.'
    },
    {
      icon: Palette,
      title: 'Инструменты',
      description: 'Используйте качественные валики и кисти, подходящие для выбранного типа краски и поверхности.'
    },
    {
      icon: Shield,
      title: 'Безопасность',
      description: 'Используйте средства защиты и обеспечьте хорошую вентиляцию при покраске и высыхании.'
    },
    {
      icon: Zap,
      title: 'Условия покраски',
      description: 'Оптимальная температура для покраски 18-25°C при влажности 40-70%. Избегайте сквозняков.'
    },
    {
      icon: Sparkles,
      title: 'Чистка инструментов',
      description: 'Тщательно очищайте инструменты сразу после работы. Для водных красок - водой, для других - растворителем.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-indigo-500" />
        Полезные советы
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-indigo-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-green-50 dark:bg-green-900/20 border border-green-100 dark:border-green-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <PaintBucket className="w-5 h-5 text-green-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-green-700 dark:text-green-300 mb-2">
              Экономия краски
            </h4>
            <p className="text-xs text-green-600 dark:text-green-400 mb-3">
              Правильная подготовка поверхности и использование грунтовки может снизить расход краски на 20-30%.
            </p>
            <div className="flex flex-col space-y-2">
              <a href="#" className="w-full py-1.5 text-xs bg-green-500 text-white rounded hover:bg-green-600 transition-colors text-center">
                Советы по экономии
              </a>
              <a href="#" className="w-full py-1.5 text-xs bg-green-100 text-green-700 dark:bg-green-900/40 dark:text-green-300 rounded hover:bg-green-200 dark:hover:bg-green-900/60 transition-colors text-center">
                Видеоинструкция
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;